import { useEffect, useState } from "react";
import Content from "./Content/Content";
import Footer from "./Footer/Footer";
import Navbar from "./Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { getUserAboutMe } from "Redux/Actions/User";
import { useLocation, useNavigate } from "react-router-dom";
import { setExceedFilterWarning } from "Redux/Slices/Common";
import { useSearchParams } from 'react-router-dom';
import { Alert, Snackbar } from "@mui/material";
import { CompareSelectionProvider } from "Explore/Context/CompareSelectionContext";
import LayoutSubscribed from "./SubscribedLayout/LayoutSubscribed";

const LayoutExplore = () => {
  const dispatch = useDispatch();
  const { useGreyBg, exceedFilterWarning } =
    useSelector((state) => state.commonState) || {};
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('preview') === 'true';
  useEffect(() => {
    if (exceedFilterWarning) {
      setSnackbarOpen(true);
    }
  }, [exceedFilterWarning]);

  const handleCloseSnackBar = () => {
    setSnackbarOpen(false);
    dispatch(setExceedFilterWarning(false));
  };

  const handleLogin = () => {
    dispatch(setExceedFilterWarning(false));
    const currentPath = location.pathname + location.search;
    navigate(`/login`, { state: { previousPage: currentPath } });
  };
  useEffect(() => {
    dispatch(getUserAboutMe());
  }, []); // ← fetch once on mount only, not on every route change

  // Show subscribed layout if user is subscribed (even while reloading,
  // use the already-cached role so the layout shell stays stable during nav)
  if (user.data?.role === "subscribed") {
    return <LayoutSubscribed />;
  }

  // Still performing the initial auth check — render nothing to avoid flash
  if (user.isLoading) {
    return null;
  }
  if (isPreview) {
    return (
      <CompareSelectionProvider>
        <Content />
      </CompareSelectionProvider>
    );
  }
  return (
    <>
      <CompareSelectionProvider>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            /* stretch so routed pages (e.g. benchmark) can use full viewport width */
            alignItems: "stretch",
            backgroundColor: useGreyBg
              ? "var(--background-color-1)"
              : "var(--background-color-2)",
          }}
        >
          <Navbar />
          <Content />
          <Footer />
        </div>
      </CompareSelectionProvider>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleCloseSnackBar}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity="warning"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Maximum filters reached.{" "}
          <span
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => handleLogin()}
          >
            Log in
          </span>{" "}
          to apply more!
        </Alert>
      </Snackbar>
    </>
  );
};

export default LayoutExplore;
